import { render } from "./TheDemandBottomCancel.vue?vue&type=template&id=4c4eae31&scoped=true"
import script from "./TheDemandBottomCancel.vue?vue&type=script&lang=js"
export * from "./TheDemandBottomCancel.vue?vue&type=script&lang=js"

import "./TheDemandBottomCancel.vue?vue&type=style&index=0&id=4c4eae31&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c4eae31"

export default script